module.exports = __webpack_public_path__ + "img/left_md_2.2e34836c.jpg";